import LinePlaneReturnIcon from 'LuxKit/Icons/line/LinePlaneReturnIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import { useIntl } from 'react-intl'

function ReturnFareFreeLabel() {
  const intl = useIntl()

  return (
    <PromotionLabel variant="default" icon={<LinePlaneReturnIcon />}>
      {intl.formatMessage({
        id: 'vya16RPxkMu_TCGtPreR',
        defaultMessage: 'Return flight free',
        description: 'Promotional badge shown when the Maldives charter return economy flight fare is free',
      })}
    </PromotionLabel>
  )
}

export default ReturnFareFreeLabel
